/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {ResponseAddUser} from '../model/ResponseAddUser';
import {ResponseStatus} from '../model/ResponseStatus';
import {SettingsTotal} from '../model/SettingsTotal';
import {UserProfileSettings} from '../model/UserProfileSettings';

/**
* Userprofile service.
* @module api/UserprofileApi
* @version 0.0.2
*/
export class UserprofileApi {

    /**
    * Constructs a new UserprofileApi. 
    * @alias module:api/UserprofileApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the addUser operation.
     * @callback moduleapi/UserprofileApi~addUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAddUser{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserProfileSettings} opts.body adding a new user to the DB
     * @param {module:api/UserprofileApi~addUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    addUser(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseAddUser;

      return this.apiClient.callApi(
        '/userprofile/user', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUser operation.
     * @callback moduleapi/UserprofileApi~getUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserProfileSettings{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} userId id of the user
     * @param {module:api/UserprofileApi~getUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUser(userId, callback) {
      
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserProfileSettings;

      return this.apiClient.callApi(
        '/userprofile/user', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getUserSettings operation.
     * @callback moduleapi/UserprofileApi~getUserSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettingsTotal{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} userId ID of the user
     * @param {module:api/UserprofileApi~getUserSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getUserSettings(userId, callback) {
      
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getUserSettings");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SettingsTotal;

      return this.apiClient.callApi(
        '/userprofile/settings', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the modifyUser operation.
     * @callback moduleapi/UserprofileApi~modifyUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseStatus{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserProfileSettings} opts.body modifiying an existing user in the database
     * @param {module:api/UserprofileApi~modifyUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    modifyUser(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseStatus;

      return this.apiClient.callApi(
        '/userprofile/user', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the userSettings operation.
     * @callback moduleapi/UserprofileApi~userSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseStatus{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} userId ID of the user
     * @param {Object} opts Optional parameters
     * @param {module:model/SettingsTotal} opts.body modifiying an existing user in the database
     * @param {module:api/UserprofileApi~userSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    userSettings(userId, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling userSettings");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseStatus;

      return this.apiClient.callApi(
        '/userprofile/settings', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}